import { useState } from "react";
import { UpdatePasswordInput } from 'aws-amplify/auth';
import { useAuth } from "src/hook/useContext";
import { BcBackground } from "src/shared/components/Bc-Background/Bc-background";
import { BcAuthMain } from "src/shared/styled/global.styled";
import BcIcon from "src/shared/components/Bc-Icon/Bc-icon";
import { FormDynamic } from "src/shared/interface/form-dynamic";
import { useForm } from "react-hook-form";
import { FormBase } from "src/shared/interface/form-base";
import SwitchFields from "src/shared/components/Bc-SwitchFields/Bc-SwitchFields";
import { Auth } from "src/auth/auth";
import { useLocalStorage } from "src/hook/useLocalStorage";
import { useNavigate } from "react-router-dom";

const FormChangePassword: FormDynamic = {
  id: "login",
  name: "Formulario Login",
  user: "masteradmin@bancolombia.com.co",
  fields: [
    {
      label: "Contraseña actual",
      item: "oldPassword",
      type: "password",
      isRequired: true,
      placeholder: "*********",
    },
    {
      label: "Contraseña Nueva",
      item: "newPassword",
      type: "password",
      isRequired: true,
      placeholder: "*********",
    },
  ],
  version: 1,
  dateCreate: new Date().toDateString(),
  dateEdit: new Date().toDateString(),
};


const ChangePassword = () => {

  const { user } = useAuth();
  const navigate = useNavigate();

  const {
    register,
    unregister,
    setValue,
    handleSubmit,
    getValues,
    watch,
    resetField,
    formState: { errors, touchedFields, dirtyFields, isValid },
  } = useForm({ mode: "onChange" });
  const onSubmit = handleSubmit((data) => {
    Auth.handleUpdatePassword(data as UpdatePasswordInput).then((r: any) => {
      console.log(r);
    }).catch((error) => {
      console.log("erro component  --->",error);
      setError(true);
      setMsj(error.message);
      
    })
  });

  const [msj, setMsj] = useState('');
  const [error, setError] = useState(false);

  console.log(user);

  if (user) {
    window.location.href="/"
  }

  const [form] = useState<FormDynamic>(FormChangePassword);


    return(<BcAuthMain><form onSubmit={onSubmit} className="bc-container bc-card-rounded">
      <BcIcon
            size="bc-2xl"
            ariaLabel="Bancolombia"
            iconName="bancolombia-horizontal"
            addClass="bc-header-brand-logo brand-center"
          />
          <h2>Cambio de contraseña</h2>
          <br />
        {form?.fields &&
          form.fields.map((field: FormBase) => (
            // eslint-disable-next-line react/jsx-no-undef
            <SwitchFields
              key={`changePassword${field.item}`}
              field={field}
              errors={errors}
              register={register}
              unregister={unregister}
              setValue={setValue}
              isRequired={field.isRequired}
              getValues={getValues}
              watch={watch}
              resetField={resetField}
              isValid={isValid}
              touchedFields={touchedFields}
              dirtyFields={dirtyFields}
            />
          ))}
          {error && <p className="msj-error">{msj}</p>}
        <button type="submit" className="bc-button-primary bc-button-small" disabled={!isValid}>Cambiar contraseña</button>

      </form>
        <BcBackground />
      </BcAuthMain>)
}

export default ChangePassword;